import { TrackingProperties } from "../..";

export enum MediaEventType {
  Click = "Click",
  Impression = "Impression",
}

export enum MediaPlacement {
  Unknown = "unknown",
  Homepage = "homepage",
  HomepageBanner = "homepage-banner",
  ExperiencesTravelWalletDrawer = "experiences-travel-wallet-drawer",
  HotelTravelWalletDrawer = "hotel-travel-wallet-drawer",
  PackagesTravelWalletDrawer = "packages-travel-wallet-drawer",
  TravelCreditsAndOffersPage = "travel-credits-and-offers-page",
  FlightTravelWalletDrawer = "flight-travel-wallet-drawer",
  CarTravelWalletDrawer = "car-travel-wallet-drawer",
  PremierCollectionTravelWalletDrawer = "premier-collection-travel-wallet-drawer",
}

export interface TrackMediaEventParams {
  eventType: MediaEventType;
  trackingProperties: TrackingProperties | undefined;
  placement: MediaPlacement;
}
